import actions from './actions';

const { LIST_PACIENTE, LIST_PACIENTE_SELECTBOX, CREATE_PACIENTE, READ_PACIENTE, UPDATE_PACIENTE, CREATE_PACIENTE_FICHA_MEDICA, READ_PACIENTE_FICHA_MEDICA, LIST_PACIENTE_HISTORIAL, PACIENTE_TOTAL_ORGANIZACION, LIST_PACIENTE_SERVICIO } = actions;

const initialState = {
  data: [],
  dataSelectBox: [],
  record: {},
  fichaMedica: {},
  historial: [],
  historialRecord: {},
  compras: {},
  compra: {},
  totalPacientesOrganizacion: 0,
};

const pacienteCrudReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case LIST_PACIENTE:
      return {
        ...state,
        data: data,
      };
    case LIST_PACIENTE_SELECTBOX:
      return {
        ...state,
        dataSelectBox: data,
      };
    case CREATE_PACIENTE:
      return {
        ...state,
        record: data,
      };
    case READ_PACIENTE:
      return {
        ...state,
        record: data,
      };
    case UPDATE_PACIENTE:
      return {
        ...state,
        record: data,
      };
    case CREATE_PACIENTE_FICHA_MEDICA:
      return {
        ...state,
        fichaMedica: data,
      };
    case READ_PACIENTE_FICHA_MEDICA:
      return {
        ...state,
        fichaMedica: data,
      };
    case LIST_PACIENTE_HISTORIAL:
      return {
        ...state,
        historial: data,
      };
    case PACIENTE_TOTAL_ORGANIZACION:
      return {
        ...state,
        totalPacientesOrganizacion: data,
      };
      case LIST_PACIENTE_SERVICIO:
      return {
        ...state,
        compras: data,
      };
    default:
      return state;
  }
};

export default pacienteCrudReducer;
